import Page from "webPage/Page";
import ScriptHelper from "base/ScriptHelper";

Page.register('page-template-contact', () => {
    if ($('.js-google-map').length > 0) {
        loadGoogleMap($('.js-google-map'));
    }

    $('body').on('click', '.js-apply', function () {
        $('body').addClass('modal-active');
        $('.js-apply-modal').addClass('modal--active');

        return false;
    }).on('click', '.js-close-modal', function () {
        $('body').removeClass('modal-active');
        $('.js-apply-modal').removeClass('modal--active');
    });

    $(document).bind('gform_post_render', function () {
        let gfRecaptchaPoller = setInterval(function () {
            if (!window.grecaptcha || !window.grecaptcha.render) {
                return;
            }
            if ($('.ginput_recaptcha').length <= 0) {
                return;
            }
            setTimeout(function () {
                renderRecaptcha();
                clearInterval(gfRecaptchaPoller);
            });
        }, 100);
    });
});

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyD8fS2SROG006UJKnn6kvhEYpWKaivkSfI").then(() => {
        loadMap($element);
    });
}

function loadMap($element) {

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: $element.data('zoom') || 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let $markers = $element.find('.js-marker');

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    $markers.each((function () {
        initMarker($(this), map);
    }));

    centerMap(map);
}

function initMarker($marker, map) {
    let latLng = {
        lat: parseFloat($marker.data('lat')),
        lng: parseFloat($marker.data('lng'))
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: {
            url: '/wp-content/themes/efx/images/svg/marker.svg',
            scaledSize: new google.maps.Size(59, 82),
            labelOrigin: new google.maps.Point(28, 82),
        }
    });

    map.markers.push(marker);
}

function centerMap(map) {

    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

const MAP_STYLES = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];
